<label class="switch">
    <input type="checkbox" [readOnly]="readonly" [(ngModel)]="value">
    <span class="slider round"></span>
</label>
